import React from 'react';
import GameAssignmentState from './gameAssignmentState/GameAssignmentState';
import GameSection from './components/GameSection/GameSection';
import RestaurantsSection from './components/RestaurantsSection/RestaurantsSection';
import ModalWindows from './components/ModalWindows/ModalWindows';
import style from './index.module.scss';

const GameAssignmentPage: React.FC = () => {
	return (
		<GameAssignmentState>
			<div className={style.container}>
				<GameSection />
				<RestaurantsSection />
			</div>
			<ModalWindows />
		</GameAssignmentState>
	);
};

export default GameAssignmentPage;
